const extraBonusStatus = {
  AVAILABLE: 0,
  RECEIVED: 1,
  UNAVAILABLE: null,
};

export default extraBonusStatus;
